import React from 'react';
import { Box, Typography, FormControl, Select, MenuItem, Button, Badge } from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import EventIcon from '@mui/icons-material/Event';
import { useNavigate } from 'react-router-dom';
import PostAddIcon from '@mui/icons-material/PostAdd'
const NewsFilters = ({ 
  filters, 
  setFilters, 
  categories,
  defaultFilters,
  user,
  countPendingNews, 
}) => {
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        display: 'flex',
        gap: 2,
        flexWrap: 'wrap',
        flexDirection: 'row',
        flex: 1,
        minWidth: 0,
      }}
    >
      <Box sx={{ minWidth: { xs: '100%', sm: 140 }, flex: 1 }}>
        <Typography
          variant="caption"
          sx={{ color: '#09274A', fontWeight: 600, mb: 1 }}
        >
          Categoría
        </Typography>
        <FormControl size="small" fullWidth>
          <Select
            value={filters.category}
            onChange={(e) => setFilters({ ...filters, category: e.target.value })}
            sx={{
              borderRadius: '8px',
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: '#e0e0e0',
              },
            }}
          >
            {categories.map((category) => (
              <MenuItem key={category} value={category} sx={{ textTransform: 'capitalize' }}>
                {category === 'all' ? 'Todas' : category}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>

      <Box sx={{ minWidth: { xs: '100%', sm: 140 }, flex: 1 }}>
        <Typography
          variant="caption"
          sx={{ color: '#09274A', fontWeight: 600, mb: 1 }}
        >
          Rango de fechas
        </Typography>
        <FormControl size="small" fullWidth>
          <Select
            value={filters.dateRange}
            onChange={(e) => setFilters({ ...filters, dateRange: e.target.value })}
            sx={{
              borderRadius: '8px',
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: '#e0e0e0',
              },
            }}
          >
            <MenuItem value="all">Todas</MenuItem>
            <MenuItem value="today">Hoy</MenuItem>
            <MenuItem value="week">Esta semana</MenuItem>
            <MenuItem value="month">Este mes</MenuItem>
          </Select>
        </FormControl>
      </Box>

      <Box sx={{ minWidth: { xs: '100%', sm: 140 }, flex: 1 }}>
        <Typography
          variant="caption"
          sx={{ color: '#09274A', fontWeight: 600, mb: 1 }}
        >
          Orden
        </Typography>
        <FormControl size="small" fullWidth>
          <Select
            value={filters.order}
            onChange={(e) => setFilters({ ...filters, order: e.target.value })}
            sx={{
              borderRadius: '8px',
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: '#e0e0e0',
              },
            }}
          >
            <MenuItem value="desc">Más recientes</MenuItem>
            <MenuItem value="asc">Más antiguas</MenuItem>
          </Select>
        </FormControl>
      </Box>
      
      
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: 2,
          justifyContent: { xs: 'flex-start', md: 'flex-end' },
          mt: 2,
        }}
      >
        <Button
          variant="outlined"
          size="small"
          startIcon={<FilterListIcon />}
          onClick={() => setFilters(defaultFilters)}
          sx={{
            borderColor: '#DC3465',
            color: '#DC3465',
            textTransform: 'none',
            minWidth: 140,
            minHeight: 40,
            padding: '6px 16px',
            lineHeight: '1.5',
            '&:hover': {
              backgroundColor: '#C42251',
              color: 'white',
            },
          }}
        >
          Quitar Filtros
        </Button>

        {user.role === 'admin' && (
          <Badge
            badgeContent={countPendingNews > 0 ? countPendingNews : null}
            color="error"
          >
            <Button
              variant="outlined"
              size="small"
              startIcon={<EventIcon />}
              onClick={() => navigate('/admin/news-requests')}
              sx={{
                borderColor: '#C42251',
                color: '#C42251',
                textTransform: 'none',
                minWidth: 140,
                minHeight: 40,
                padding: '6px 16px',
                lineHeight: '1.5',
                '&:hover': {
                  backgroundColor: 'rgba(196, 34, 81, 0.1)',
                  borderColor: '#A01D45',
                },
              }}
            >
              Revisar Solicitudes
            </Button>
          </Badge>
        )}

        <Button
          variant="contained"
          size="small"
          startIcon={<PostAddIcon />}
          onClick={() => navigate('/news-form')}
          sx={{
            background: 'linear-gradient(to right, #09274A, #0488AF)',
            color: '#fff',
            textTransform: 'none',
            minWidth: 140,
            minHeight: 40,
            padding: '6px 16px',
            lineHeight: '1.5',
            '&:hover': {
              background: 'linear-gradient(to right, #071f3d, #03779C)',
            },
          }}
        >
          {user.role === 'admin' ? 'Nueva Noticia' : 'Crear Noticia'}
        </Button>
      </Box>

    </Box>
  );
};

export default NewsFilters;